import ReactDOM from 'react-dom';
import App from './App';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

ReactDOM.render(
	<App baseUrl={baseUrl} />,
	document.getElementById('root')
);
